import React, { useCallback, useEffect, useState } from "react";
import { notBlank } from "../../../util/ext";

import Container from "@mui/material/Container";
import { useParams } from "react-router-dom";
import AnthologyEditDialog from "./AnthologyEditDialog";

const AnthologyEdit = props => {
  const { onCancel } = props;
  const { id } = useParams();
  const [editVisible, setEditVisible] = useState(false);

  const handleCancel = useCallback(() => {
    setEditVisible(false);
    onCancel();
  }, [onCancel]);

  useEffect(() => {
    if (notBlank(id)) {
      setEditVisible(true);
    } else {
      setEditVisible(false);
    }
  }, [id]);

  return (
    <Container>
      <AnthologyEditDialog
        id={id}
        visible={editVisible}
        onCancel={handleCancel}
      />
    </Container>
  );
};

export default AnthologyEdit;
